// Interfaces
import { IStyles } from '../../resource';

// Define styles
const styles: IStyles = {
  dialog: (theme) => ({
    height: { xs: 'calc(100vh - 158px)', md: 'calc(100vh - 110px)' },
    top: { xs: theme.spacing(158), md: theme.spacing(110) },
    left: { xs: theme.spacing(0), md: theme.spacing(96) },
    '.MuiBackdrop-root': {
      top: { xs: theme.spacing(158), md: theme.spacing(110) },
      left: { xs: theme.spacing(0), md: theme.spacing(96) },
    },
  }),
  container: () => ({
    position: 'absolute',
    top: 24,
    right: 24,
    bottom: 24,
    left: 24,
    width: 'auto',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':focus': {
      outline: 'none',
    },
  }),
  headerActions: () => ({
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  }),
};

// Export styles
export default styles;
